<template>
  <v-layout v-if="subUsers" row wrap>
    <v-flex xs12 pa-2>    
       <addBtn :text="lang.add_subuser"  @click="addSubUser()"></addBtn>
     
    </v-flex>
    <v-flex xs12 pa-2>
      <v-data-table
        :headers="headers"
        :items="subUsers"
        :search="search"
        item-key="email"
        class="elevation-1"
        :loading="subUsers.length<=0 && !timeoutSubUsers"
        loading-text="Loading... Please wait"
      >
        <template slot="item" slot-scope="items">
          <tr>
            <td>{{ items.item }}</td>
            <td align="center">
              <v-btn text icon @click="{{openDialog(items.item)}}" color="primary">
                <v-icon small class="fa-light fa-xmark red--text"></v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
        <template v-slot:no-data>{{lang.no_sub_users}}</template>
      </v-data-table>
    </v-flex>
    <dialogConfirm
      :dialog="deleteConfirm"
      :title="lang.deleteConfirmSubUser"
      :msg="lang.deleteMsgSubUser"
      @onConfirm="deleteSubUser()"
      @onCancel="cancelDelete()"
    />
    <addSubUser :dialog="addDialog" :email="email" @close="addDialog=false" />
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import addSubUser from "./add_sub_user";
import dialogConfirm from "@/components/dialogConfirm";
const utils = require("@/classes/utils/utils.js").Utils;
import addBtn from "@/components/addBtn";
const manage = require("./manage.js").manage;
export default {
  data() {
    return {
      search: "",
      headers: [],
      timeoutSubUsers: false,
      addDialog: false,
      deleteConfirm: false
    };
  },
  components: {
    addSubUser,
    dialogConfirm,
    addBtn
  },
  computed: {
    ...mapState(["lang", "adminUser"])
  },
  props: {
    email: {
      default: false
    },
    user: {
      default: false
    },
    subUsers: {
      default: false
    }
  },
  methods: {
    getSubUsersCount() {
      if (this.subUsers != null) {
        return this.lang.sub_users + " (" + this.subUsers.length + ")";
      }
    },
    addSubUser() {
      this.addDialog = true;
    },
    endTimeout() {
      this.timeoutSubUsers = true;
    },
    openDialog(email) {
      this.deleteConfirm = true;
      this.currentSubUser = email;
    },
    deleteSubUser() {
      this.pageLoading = true;
      manage.deleteSubUser(this.email, this.currentSubUser);
      this.currentSubUser = "";
      this.deleteConfirm = false;
    },
    cancelDelete() {
      this.currentSubUser = "";
      this.deleteConfirm = false;
    }
  },
  mounted() {
    this.timeout = false;
    this.headers = [
      { text: this.lang.sub_users, value: "email" },
      { text: "", value: "delete", align: "center" }
    ];
    setTimeout(this.endTimeout, 5000);
  }
};
</script>